FaqBreadcrumbTemplate = require('../../breadcrumb.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $
FAQMainView = require('./main')

class FAQBreadCrumbView extends Backbone.View
  initialize: ->
    @I18nScope = 'modules.faq'
    @template = FaqBreadcrumbTemplate
    @container = $('#breadcrumb')
    @invalidate()

  invalidate: ->
    @container.empty()
    @searchHistory = new Array(@constructFaqMainbreadCrumb())

  # save data for a particular level in History
  addCrumbs : (levelResponse) ->
    if levelResponse? && levelResponse.searchId? && levelResponse.text?
      @searchHistory.push(levelResponse)
      return true
    else
      return false

  render :() ->
    @toHtml()

  toHtml : () ->
    @$el.html toHtml(@template, @toHash(@searchHistory), @I18nScope)
    @container.html(@el)

  toHash : (history) ->
    if history?.length > 0
      breadCrumbs = history
      breadCrumbs[ breadCrumbs.length - 1 ].isCurrentLevel = true
      return {
        levels : breadCrumbs
        show : if breadCrumbs?.length > 1 then true else false
      }
    else
      return null

  constructFaqMainbreadCrumb : () ->
    hash =
      searchId : FAQMainView.VIEWNAME
      text : I18n.t('js.modules.faq.faq_main')
    return hash

module.exports = FAQBreadCrumbView
